import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import styles from './AuthBar.module.css'
import Button from '../../ui/button'
import { LoginIcon, LogoutIcon } from '../../ui/icon'

export default function StatusBar() {
    const { user, isAuthenticated, isLoading, loginWithRedirect, logout } = useAuth0()

    if (isLoading) {
        return <div className={styles.container}>Loading...</div>;
    }

    if (!isAuthenticated) {
        return (
            <div className={styles.container}>
                <Button icon={LoginIcon} onClick={() => loginWithRedirect()} />
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <div className={styles.avatar}>
                <img src={user?.picture} alt={user?.name} />
            </div>
            <Button icon={LogoutIcon} onClick={() => logout({ returnTo: window.location.origin })} />
        </div>
    )
}